var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["modal/user/email-signup/email-signup-checkboxes.j2"] = require( "modal/user/email-signup/email-signup-checkboxes.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/email-signup/email-signup-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/user/email-signup/email-signup-form.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("validatedField")) {
var t_4 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_6 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_6);
if(t_1.hasOwnProperty("hasErrors")) {
var t_7 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_7);
output += "\n\n\n<form novalidate class=\"js-email-signup-form ";
output += runtime.suppressValue((lineno = 3, colno = 55, runtime.callWrap(t_7, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"messages")),"generalErrors")])), env.opts.autoescape);
output += "\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\" data-parsley-validate data-qa-signup-modal>\n\n    <div class=\"c-email-signup\">\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <h2 class=\"c-email-signup__h2\">\n                    ";
output += runtime.suppressValue((lineno = 12, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-header"])), env.opts.autoescape);
output += "\n                </h2>\n\n                <p class=\"c-email-signup__p\">\n                    ";
output += runtime.suppressValue((lineno = 16, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-copy"])), env.opts.autoescape);
output += "\n                </p>\n            </div>\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"messages")),"generalErrors")) {
output += "\n                    ";
output += runtime.suppressValue((lineno = 25, colno = 41, runtime.callWrap(t_6, "displayGeneralErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"messages")),"generalErrors")])), env.opts.autoescape);
output += "\n                ";
;
}
output += "\n\n                <div class=\"c-email-signup__form c-form__field c-form__field--required ";
output += runtime.suppressValue((lineno = 28, colno = 97, runtime.callWrap(t_7, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"messages")),"email")])), env.opts.autoescape);
output += "\">\n\n                    <label for=\"signup-email\" class=\"c-form__label\">\n                        ";
output += runtime.suppressValue((lineno = 31, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-email-label"])), env.opts.autoescape);
output += "\n                    </label>\n\n                    <input data-parsley-type=\"email\" ";
output += runtime.suppressValue((lineno = 34, colno = 68, runtime.callWrap(t_4, "validatedField", context, ["ERROR_EMAIL_SIGNUP_INVALID_USERNAME",runtime.makeKeywordArgs({"field": runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"messages")),"email")})])), env.opts.autoescape);
output += " value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"email"), env.opts.autoescape);
output += "\" type=\"email\" name=\"email\" id=\"signup-email\" class=\"c-form__text\" data-qa-signup-email-field aria-describedby=\"signup-email_error\"/>\n\n                    ";
output += runtime.suppressValue((lineno = 36, colno = 39, runtime.callWrap(t_5, "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"messages")),"email"),runtime.makeKeywordArgs({"id": "signup-email"})])), env.opts.autoescape);
output += "\n\n                </div>\n\n                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"userLocation")),"isUS") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteConfig")),"siteGroup") == "an-us") {
output += "\n                    ";
env.getTemplate("modal/user/email-signup/email-signup-checkboxes.j2", false, "core/templates/modal/user/email-signup/email-signup-form.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n                ";
})});
}
output += "\n\n                <button type=\"submit\" class=\"c-button-primary js-email-signup\" data-email-signup-source=\"Site Footer\" data-qa-email-signup-button>\n                    ";
output += runtime.suppressValue((lineno = 45, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-submit-button"])), env.opts.autoescape);
output += "\n                </button>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <p class=\"c-email-signup__details\">\n                    ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, (lineno = 57, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-disclaimer"]))), env.opts.autoescape);
output += "\n                </p>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</form>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/email-signup/email-signup-form.j2"] , dependencies)